export const resolveDisableFrequencies = ({
	marketSharesMetrics = [],
	financialStatementsMetrics = [],
	section,
	make,
	frequencies,
	makeOem,
	sectionId,
	locationOEMs,
}) => {
	let activeFrequencies;

	switch (section) {
		case "GrowthBonus": {
			activeFrequencies = resolveGrowthBonusActiveFrequencies({ financialStatementsMetrics, make, makeOem, locationOEMs });
			break;
		}
		case "MarketShare": {
			activeFrequencies = resolveMarketShareActiveFrequencies({ marketSharesMetrics, make });
			break;
		}
		case "DefaultGross": {
			activeFrequencies = resolveDefaultGrossActiveFrequencies({
				financialStatementsMetrics,
				makeOem,
				sectionId,
				locationOEMs,
			});
			break;
		}
		case "OperatingCosts": {
			activeFrequencies = resolveOperatingCostsActiveFrequencies({
				financialStatementsMetrics,
				makeOem,
				locationOEMs,
			});
			break;
		}
		default: {
			activeFrequencies = [];
			break;
		}
	}

	return frequencies?.filter((item) => !Array.from(new Set(activeFrequencies))?.includes(item?.value))?.map((item) => item?.value);
};

const filterByFranchise = ({ itemFS, makeOem }) => {
	const filteredByOEM = itemFS?.oemReference === makeOem?.oemReference && itemFS?.dealerCodeFS === makeOem?.dealerCodeFS;
	const filteredByFranchise = makeOem?.franchises?.every((franchise) => {
		return franchise.isCombined
			? franchise.groups.every((group) => itemFS?.franchises?.includes(group?.franchiseName?.toUpperCase()))
			: itemFS?.franchises?.includes(franchise?.franchise?.toUpperCase());
	});
	return filteredByOEM && filteredByFranchise;
};

const resolveGrowthBonusActiveFrequencies = ({ financialStatementsMetrics, make, makeOem, locationOEMs }) => {
	const pageName = make === "Pre-Owned Vehicles" ? "preownedPage" : undefined;
	const filteredMetrics =
		make !== "New Vehicles"
			? financialStatementsMetrics?.filter((itemFS) => itemFS[pageName] || filterByFranchise({ itemFS, makeOem }))
			: financialStatementsMetrics;

	return resolveActiveFrequencies({ filteredMetrics, locationOEMs, makeOem, isPreownedPage: pageName });
};

const resolveMarketShareActiveFrequencies = ({ marketSharesMetrics, make }) => {
	return marketSharesMetrics
		?.filter((metricItem) => metricItem?.franchises?.includes(make?.toUpperCase()))
		?.map((metricItem) => metricItem?.frequency);
};

const resolveOperatingCostsActiveFrequencies = ({ financialStatementsMetrics, makeOem, locationOEMs }) => {
	const filteredMetrics = makeOem
		? financialStatementsMetrics?.filter(
				(item) => item?.oemReference === makeOem?.oemReference && item?.dealerCodeFS === makeOem?.dealerCodeFS
		  )
		: financialStatementsMetrics;
	return resolveActiveFrequencies({ filteredMetrics, locationOEMs, makeOem });
};

const resolveDefaultGrossActiveFrequencies = ({ financialStatementsMetrics, makeOem, sectionId, locationOEMs }) => {
	const pageName = `${sectionId}Page`;

	const filteredMetrics = makeOem
		? financialStatementsMetrics?.filter(
				(item) =>
					item[pageName]?.length && item?.oemReference === makeOem?.oemReference && item?.dealerCodeFS === makeOem?.dealerCodeFS
		  )
		: financialStatementsMetrics?.filter((item) => item[pageName]?.length);

	return resolveActiveFrequencies({ filteredMetrics, locationOEMs, makeOem });
};

const resolveActiveFrequencies = ({ filteredMetrics, locationOEMs, makeOem, isPreownedPage }) => {
	const frequencyMap = {};
	const oemLength = !makeOem ? locationOEMs?.length : 1;

	for (const metric of filteredMetrics) {
		frequencyMap[metric.frequency] = (frequencyMap[metric.frequency] || 0) + 1;
	}

	return Object.entries(frequencyMap).reduce((acc, [key, value]) => {
		if (value === oemLength || (isPreownedPage && value)) {
			acc.push(key);
		}
		return acc;
	}, []);
};
